// ตัวช่วยดักข้อความตอนพิมพ์ — ใช้กับ onChange ของช่องกรอก

// เก็บเฉพาะตัวเลข และตัดไม่เกิน max ตัว
export const digitsOnly = (value: string, max: number): string =>
  value.replace(/\D/g, '').slice(0, max)

export const PHONE_MAX = 10
export const TAX_ID_MAX = 13

export const filterPhone = (value: string): string => digitsOnly(value, PHONE_MAX)
export const filterTaxId = (value: string): string => digitsOnly(value, TAX_ID_MAX)

// เบอร์มือถือ/บ้านไทยต้องขึ้นต้น 0 และยาว 9–10 หลัก
export const isValidPhone = (value: string): boolean => /^0\d{8,9}$/.test(value)
export const isValidTaxId = (value: string): boolean => /^\d{13}$/.test(value)
